export const AP_TRAINING_CATALOG_LOADER = {
  desktop: `<div class="cui cui-grid cui-container">
  <div class="cui-skeleton-heading -size--large -spacing--top-64 -spacing--bottom-20 -resolution--desktop">
    <div class="cui-skeleton-heading__content" style="width: max(300px, 100%)">
      <div class="cui-skeleton__item cui-skeleton-heading__title"></div>
      <div class="cui-skeleton__item cui-skeleton__description"></div>
    </div>
  </div>
  <div class="cui-skeleton-input -size--medium -spacing--top-64 -spacing--bottom-40 -resolution--desktop">
    <div class="cui-skeleton-input__content" style="width: min(100%, 540px)">
      <div class="cui-skeleton__item cui-skeleton-input__field"></div>
    </div>
  </div>

  <div class="cui-skeleton-rectangle -spacing--bottom-40 -resolution--desktop" style="display: flex; gap: 16px">
    <div class="cui-skeleton__item" style="width: 172px; height: 48px; border-radius: 24px"></div>
    <div class="cui-skeleton__item" style="width: 172px; height: 48px; border-radius: 24px"></div>
    <div class="cui-skeleton__item" style="width: 172px; height: 48px; border-radius: 24px"></div>
    <div class="cui-skeleton__item" style="width: 172px; height: 48px; border-radius: 24px"></div>
  </div>

  <div class="cui-grid">
    <div class="cui-row">
      <div class="cui-col-lg-3">
        <div class="cui-skeleton-rectangle -is--block">
          <div class="cui-skeleton__item" style="width: 100%; height: 266px"></div>
        </div>
      </div>
      <div class="cui-col-lg-3">
        <div class="cui-skeleton-rectangle -is--block">
          <div class="cui-skeleton__item" style="width: 100%; height: 266px"></div>
        </div>
      </div>
      <div class="cui-col-lg-3">
        <div class="cui-skeleton-rectangle -is--block">
          <div class="cui-skeleton__item" style="width: 100%; height: 266px"></div>
        </div>
      </div>
      <div class="cui-col-lg-3">
        <div class="cui-skeleton-rectangle -is--block">
          <div class="cui-skeleton__item" style="width: 100%; height: 266px"></div>
        </div>
      </div>
    </div>
    <div>
      <div class="cui-skeleton-rectangle -is--block -spacing--top-40 -spacing--bottom-120" style="display: flex; justify-content: center">
        <div class="cui-skeleton__item" style="width: 160px; height: 40px"></div>
      </div>
    </div>
  </div>
  <div class="cui-skeleton-rectangle -is--block -spacing--top-96">
    <div class="cui-skeleton__item" style="width: 100%; height: 124px"></div>
  </div>
</div>
`,
  mobile: ` 
<div class="cui cui-grid cui-container">
  <div class="cui-skeleton-heading -size--large -spacing--top-32 -spacing--bottom-20 -resolution--mobile">
    <div class="cui-skeleton-heading__content" style="width: max(300px, 100%)">
      <div class="cui-skeleton__item cui-skeleton__description -spacing--bottom-40"></div>
      <div class="cui-skeleton__item cui-skeleton-heading__title" style = "width: 200px; height: 40px;"></div>
      <div class="cui-skeleton__item cui-skeleton__description"></div>
      <div class="cui-skeleton__item cui-skeleton__description"></div>
    </div>
  </div>
  <div class="cui-skeleton-rectangle -is--block -spacing--top-24">
    <div class="cui-skeleton__item" style="width: 175px; height: 24px"></div>
  </div>
  <div class="cui-skeleton-rectangle -is--block -spacing--top-24">
    <div class="cui-skeleton__item" style="width: 200px; height: 36px"></div>
  </div>
  <div class="cui-skeleton-rectangle -is--block -spacing--top-24">
    <div class="cui-skeleton__item" style="width: 175px; height: 24px"></div>
  </div>
  <div class="cui-skeleton-rectangle -is--block -spacing--top-24">
    <div class="cui-skeleton__item" style="width: 100%; height: 40px"></div>
  </div>
  <div class="cui-skeleton-rectangle -is--block -spacing--top-24">
    <div class="cui-skeleton__item" style="width: 100%; height: 40px"></div>
  </div>
  <div class="cui-skeleton-rectangle -is--block -spacing--top-24">
    <div class="cui-skeleton__item" style="width: 100%; height: 40px"></div>
  </div>
  <div class="cui-grid">
      <div class="cui-skeleton-rectangle -is--block -spacing--top-24">
          <div class="cui-skeleton__item" style="width: 100%; height: 266px;"></div>
        </div>
      <div class="cui-skeleton-heading -size--medium -resolution--mobile -spacing--top-24">
          <div class="cui-skeleton-rectangle -is--block">
            <div class="cui-skeleton__item" style="width: 100%; height: 266px;"></div>
          </div>
        </div>
      <div class="cui-skeleton-rectangle -is--block -spacing--top-24">
          <div class="cui-skeleton__item" style="width: 100%; height: 266px;"></div>
        </div>
        <div class="cui-skeleton-rectangle -is--block -spacing--top-24 -spacing--bottom-24">
          <div class="cui-skeleton__item" style="width: 100%; height: 266px;"></div>
        </div>
      <div class="cui-skeleton-rectangle -is--block -spacing--top-24 -spacing--bottom-120">
        <div class="cui-skeleton__item" style="width: 100% ; height: 64px"></div>
      </div>
  </div>
</div>
<div class="cui-skeleton-rectangle -is--block -spacing--top-96">
    <div class="cui-skeleton__item" style="width: 100%; height: 220px"></div>
</div>`
};
